async function addBundleToCart(
  bundleProductData,
  selectedProductsArray,
  addToCart,
  resetQuantitiesToZero,
  updateBOBSummary,
  BOBSelection,
  quantityInputs,
  totalQuantity,
  totalPrice,
  limit,
  summaryTarget,
  updateTarget,
  priceContainers,
  storeCurrency
) {
  cart =
    document.querySelector("cart-notification") ||
    document.querySelector("cart-drawer");
  // Check if the addToCart button is not disabled
  if (!addToCart.disabled && parseInt(totalQuantity) === parseInt(limit)) {
    console.log(
      "checking quantities",
      parseInt(totalQuantity),
      parseInt(limit)
    );
    addToCart.classList.add("loading");
    addToCart
      .querySelector(".loading-overlay__spinner")
      .classList.remove("hidden");

    // Filter out products with quantity 0 from selectedProductsArray
    let productsArrayToSubmit = selectedProductsArray;

    productsArrayToSubmit = productsArrayToSubmit.filter(
      (obj) => obj.quantity !== 0
    );

    const timeStamp = Date.now();

    // Create a string representation of products for the cart
    const stringProductsForCart = productsArrayToSubmit
      .map((item) => `${item.quantity} × ${item.productTitle}`)
      .join(", ");

    //individual hidden cans to submit
    let individualCans = [];
    productsArrayToSubmit.map((item) => {
      individualCans.push({
        quantity: item.quantity,
        id: item.externalVariantId,
        properties: {
          _build_a_box: true,
          _individual_can: true,
          _timestamp: `${timeStamp}`,
        },
      });
    });
    // Create a bundle object with the necessary data
    const bundle = {
      externalVariantId: bundleProductData.variantId,
      externalProductId: bundleProductData.productId,
      selections: productsArrayToSubmit,
    };

    let itemsForCart = [];

    itemsForCart = [
      {
        id: bundleProductData.variantId,
        quantity: 1,

        properties: {
          items: stringProductsForCart,
          _build_a_box: true,
          _bab_parent: true,
          _timestamp: `${timeStamp}`,
          _total_price: document.querySelector(".pricing-container").innerHTML,
        },
      },
    ];

    // Create cart data with the individual cans
    const cartData = {
      items: individualCans,
    };

    try {
      // Add the cart data to the cart using the Shopify API
      await fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(cartData),
      });
    } catch (error) {
      console.error(error);
    }

    const formData = new FormData(addToCart.closest("form"));
    if (cart) {
      formData.append(
        "sections",
        cart.getSectionsToRender().map((section) => section.id)
      );
      formData.append("sections_url", window.location.pathname);
      cart.setActiveElement(document.activeElement);
    }
    for (const item of itemsForCart) {
      if (item.properties?.items) {
        formData.append("properties[items]", item.properties["items"]);
      }

      if (item.properties?._build_a_box) {
        formData.append(
          "properties[_build_a_box]",
          item.properties["_build_a_box"]
        );
      }

      if (item.properties?._total_price) {
        formData.append(
          "properties[_total_price]",
          item.properties["_total_price"]
        );
      }

      if (item.properties?._bab_parent) {
        formData.append(
          "properties[_bab_parent]",
          item.properties["_bab_parent"]
        );
      }

      if (item.properties?._timestamp) {
        formData.append(
          "properties[_timestamp]",
          item.properties["_timestamp"]
        );
      }

      if (item.quantity) {
        formData.append("quantity", item.quantity);
      }

      if (item.id) {
        formData.append("id", item.id);
      }
    }

    const config = fetchConfig("javascript");
    config.headers["X-Requested-With"] = "XMLHttpRequest";
    delete config.headers["Content-Type"];
    config.body = formData;

    fetch(`${window.routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        if (cart) {
          cart.renderContents(response);
        }

        //  document.dispatchEvent(cartChange);
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        addToCart.classList.remove("loading");
        if (cart && cart.classList.contains("is-empty"))
          cart.classList.remove("is-empty");
        addToCart.removeAttribute("aria-disabled");

        addToCart
          .querySelector(".loading-overlay__spinner")
          .classList.add("hidden");

        const initialState = addToCart.innerHTML;
        addToCart.innerHTML = "Added!";

        setTimeout(() => {
          addToCart.innerHTML = initialState;
          resetQuantitiesToZero(
            selectedProductsArray,
            updateBOBSummary,
            BOBSelection,
            quantityInputs,
            addToCart,
            totalQuantity,
            totalPrice,
            limit,
            summaryTarget,
            updateTarget,
            priceContainers,
            storeCurrency
          );
        }, 2000);

        resetQuantitiesToZero(
          selectedProductsArray,
          updateBOBSummary,
          BOBSelection,
          quantityInputs,
          addToCart,
          totalQuantity,
          totalPrice,
          limit,
          summaryTarget,
          updateTarget,
          priceContainers,
          storeCurrency
        );

        return selectedProductsArray;
      });
  }
}

function updateSelectedProductQuantities(
  productId,
  quantity,
  selectedProductsArray,
  updateBOBSummary,
  BOBSelection,
  quantityInputs,
  calculateTotalAddedQuantities,
  totalQuantity,
  totalPrice,
  addToCart,
  limit,
  summaryTarget,
  updateTarget,
  priceContainers,
  storeCurrency
) {
  // Update the quantity of the selected product in the selectedProductsArray
  for (const item of selectedProductsArray) {
    if (item.externalProductId === productId) {
      item.quantity = quantity;

      // Update the BOB summary
      updateBOBSummary(
        selectedProductsArray,
        BOBSelection,
        quantityInputs,
        addToCart,
        totalQuantity,
        totalPrice,
        limit,
        summaryTarget,
        updateTarget,
        priceContainers,
        storeCurrency
      );
      // Calculate the total added quantities
      [totalQuantity, totalPrice] = calculateTotalAddedQuantities(
        selectedProductsArray,
        totalQuantity,
        totalPrice,
        limit,
        summaryTarget,
        updateTarget,
        priceContainers,
        storeCurrency
      );
      // Return the updated totalQuantity and selectedProductsArray

      return [totalQuantity, totalPrice, selectedProductsArray];
    }
  }
}

function updateBundleSellingPlan(
  el,
  bundleProductData,
  sellingPlanToggle,
  sellingPlanDropdown
) {
  // Check if the selling plan toggle is unchecked

  if (el === sellingPlanToggle && !sellingPlanToggle.checked) {
    // Remove the selling plan from bundleProductData
    delete bundleProductData.sellingPlan;
    // Remove the "active" class from the subscriptionOptions element
    sellingPlanDropdown
      .closest(".subscription__options")
      .classList.remove("active");
    // Disable the selling plan dropdown
    sellingPlanDropdown.disabled = true;

    document
      .querySelector(".gift-message--subscription")
      .classList.remove("active");
  } else {
    // Update the selling plan in bundleProductData
    bundleProductData.sellingPlan = parseInt(sellingPlanDropdown.value);
    // Add the "active" class to the subscriptionOptions element
    sellingPlanDropdown
      .closest(".subscription__options")
      .classList.add("active");
    // Enable the selling plan dropdown
    sellingPlanDropdown.disabled = false;

    document
      .querySelector(".gift-message--subscription")
      .classList.add("active");
  }
}

function updateBundleVariantId(el, bundleProductData) {
  // Update the variant ID in bundleProductData
  bundleProductData.variantId = el.value;
}

function displayRelevantPrice(priceContainer, el, subscriptionOptions) {
  // Add or remove the "price--subscription" class based on whether the checkbox is checked
  if (el.checked) {
    priceContainer.classList.add("price--subscription");
    // subscriptionOptions.classList.add("active");
  } else {
    priceContainer.classList.remove("price--subscription");
    //subscriptionOptions.classList.remove("active");
  }
}

function updateBOBSummary(
  selectedProductsArray,
  BOBSelection,
  quantityInputs,
  addToCart,
  totalQuantity,
  totalPrice,
  limit,
  summaryTarget,
  updateTarget,
  priceContainers,
  storeCurrency
) {
  // Clear the BOB selection HTML
  BOBSelection.innerHTML = "";
  // Loop through selectedProductsArray and add items with quantity > 0 to the BOB selection

  for (const item of selectedProductsArray) {
    if (item.quantity > 0) {
      // Create a summary item element
      const summaryItem = document.createElement("li");
      // Set the HTML content of the summary item
      summaryItem.innerHTML = `<span class="item__title">${item.productTitle}</span><span>${item.quantity}</span> <button data-product-id="${item.externalProductId}"><svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_2240_12371)">
      <path d="M7.503 15.506C11.6468 15.506 15.006 12.1468 15.006 8.003C15.006 3.85921 11.6468 0.5 7.503 0.5C3.35921 0.5 0 3.85921 0 8.003C0 12.1468 3.35921 15.506 7.503 15.506Z" fill="black"/>
      <path d="M4.11426 10.588L6.68123 8.00302L4.11426 5.43605L4.93593 4.61438L7.5029 7.18135L10.0699 4.61438L10.8736 5.39407L8.30658 7.97903L10.8915 10.564L10.0699 11.3857L7.48491 8.80071L4.91794 11.3677L4.11426 10.588Z" fill="white"/>
      </g>
      <defs>
      <clipPath id="clip0_2240_12371">
      <rect width="15" height="15" fill="white" transform="translate(0 0.5)"/>
      </clipPath>
      </defs>
      </svg>
          </button>`;
      // Append the summary item to the BOBSelection element
      BOBSelection.appendChild(summaryItem);

      // Add an event listener to the remove button
      summaryItem.querySelector("button").addEventListener("click", (e) => {
        // Find the corresponding item in selectedProductsArray and set its quantity to 0
        for (const item of selectedProductsArray) {
          if (e.target.dataset.productId === item.externalProductId) {
            item.quantity = 0;
            // Remove the summary item from the DOM
            e.target.closest("li").remove();
            // Set the quantity input value to 0
            for (const input of quantityInputs) {
              if (e.target.dataset.productId === input.dataset.productId) {
                input.value = 0;
              }
              input.nextElementSibling.disabled = false;
            }
            addToCart.disabled = true;

            //update messaging for 'spaces left'
            calculateTotalAddedQuantities(
              selectedProductsArray,
              totalQuantity,
              totalPrice,
              limit,
              summaryTarget,
              updateTarget,
              priceContainers,
              storeCurrency
            );
          }
        }
      });
    }
  }
}

function resetQuantitiesToZero(
  selectedProductsArray,
  updateBOBSummary,
  BOBSelection,
  quantityInputs,
  addToCart,
  totalQuantity,
  totalPrice,
  limit,
  summaryTarget,
  updateTarget,
  priceContainers,
  storeCurrency
) {
  // Reset the quantities of all items in selectedProductsArray to 0
  for (const item of selectedProductsArray) {
    item.quantity = 0;
  }

  // Update the BOB summary
  updateBOBSummary(
    selectedProductsArray,
    BOBSelection,
    quantityInputs,
    addToCart,
    totalQuantity,
    totalPrice,
    limit,
    summaryTarget,
    updateTarget,
    priceContainers,
    storeCurrency
  );

  // Reset the quantity input values to 0
  for (const input of quantityInputs) {
    input.value = 0;
  }

  updateTarget(
    totalQuantity,
    totalPrice,
    limit,
    summaryTarget,
    priceContainers,
    storeCurrency
  );

  //disable atc
  addToCart.disabled = true;
  //re-enable quantity inputs
  quantityInputs.forEach((input) => {
    input.nextElementSibling.disabled = false;
  });
}

function setLimit(
  totalQuantity,
  totalPrice,
  limit,
  summaryTarget,
  el,
  updateTarget,
  priceContainers,
  storeCurrency
) {
  // Set the limit to the value of the selected element
  limit = parseInt(el.value);

  updateTarget(
    totalQuantity,
    totalPrice,
    limit,
    summaryTarget,
    priceContainers,
    storeCurrency
  );
  return limit;
}

function calculateTotalAddedQuantities(
  selectedProductsArray,
  totalQuantity,
  totalPrice,
  limit,
  summaryTarget,
  updateTarget,
  priceContainers,
  storeCurrency
) {
  // Calculate the total quantity of all selected products
  totalQuantity = 0;
  for (const item of selectedProductsArray) {
    totalQuantity += parseInt(item.quantity);
  }

  totalPrice = 0;

  for (const item of selectedProductsArray) {
    totalPrice += parseInt(item.price) * parseInt(item.quantity);
  }

  updateTarget(
    totalQuantity,
    totalPrice,
    limit,
    summaryTarget,
    priceContainers,
    storeCurrency
  );

  return [totalQuantity, totalPrice];
}

function updateTarget(
  totalQuantity,
  totalPrice,
  limit,
  summaryTarget,
  priceContainers,
  storeCurrency
) {
  const spacesLeft = limit - totalQuantity;

  if (spacesLeft === 0) {
    (
      summaryTarget?.querySelector("span") || summaryTarget
    ).innerHTML = `Add to cart`;
  } else if (totalQuantity === 0 || spacesLeft <= 0) {
    (
      summaryTarget?.querySelector("span") || summaryTarget
    ).innerHTML = `Add ${limit} more can${limit === 1 ? "" : "s"}`;
  } else {
    (
      summaryTarget?.querySelector("span") || summaryTarget
    ).innerHTML = `Add ${spacesLeft} more can${spacesLeft === 1 ? "" : "s"}`;
  }

  priceContainers.textContent = `${storeCurrency}${(totalPrice / 100).toFixed(
    2
  )}`;
}
